import { gql } from "@apollo/client";

export const VEHICLE_TICKET_HISTORY_QUERY = gql`
  query VEHICLE_TICKET_HISTORY_QUERY($originatorId: ID!, $vehicleId: ID!) {
    vehicleTicketHistory(originatorId: $originatorId, vehicleId: $vehicleId) {
      id
      ticketNumber
      doNotSubmit
      incident {
        id
        incidentNumber
        sealed
        locked
      }
      issuedTo {
        id
        personalAttribute {
          id
          lastName
          middleName
          firstName
        }
      }
      ticketViolationPrototype {
        id
        fullName
        name
      }
      accident
    }
  }
`;
